function substituirTituloRelacionados() {
  const etapa = document.getElementById("HdEtapaLoja")?.value;

  if (etapa !== "PRODUTO") return;

  const titulos = document.querySelectorAll(".prod-related-container .prod-list-titles-title");

  titulos.forEach((titulo) => {
    titulo.outerHTML = `
      <span class="custom-title-prodlist">
        Quem viu,
        <span class="custom-subtitle-prodlist">viu também</span>
      </span>
    `;
  });
}

try {
  isReady("categorias", substituirTituloRelacionados);
} catch (error) {}

function aplicarLabelPix() {
  const info = wsMain?.globalData?.infoProduto;
  const label = document.querySelector("[data-prod-pix-label]");
  const containerPix = document.querySelector(".container-pix");
  const pricePix = document.querySelector(".prod-price-pix");
  if (!containerPix || !pricePix) return;

  const desconto = info?.precos?.desconto_avista;

  if (desconto && desconto > 0) {
    /* Produto com desconto PIX: exibe normalmente com tag */
    if (label) {
      label.textContent = `-${desconto}% no PIX`;
    }
  } else {
    /* Produto sem desconto PIX: exibe preco_promocao no lugar do PIX */
    if (label) {
      label.textContent = "";
      label.style.display = "none";
    }
    const precoPromo = info?.precos?.preco_promocao || info?.precos?.preco;
    if (precoPromo) {
      const formatado = precoPromo.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      pricePix.textContent = formatado;
      pricePix.removeAttribute("data-wsjs-force");
    }
  }
}

function ajustarPrecoDeProduto() {
  const precoDe = document.querySelector(".available-section .prod-price-of");
  const parcela = document.querySelector(".available-section .prod-price-installment-content");

  if (!precoDe || !parcela) return;

  const obterPrimeiroPreco = (texto) => {
    const match = String(texto || "").match(/R\$\s*[\d.]+,\d{2}/);
    return match ? textoPrecoParaNumeroProduto(match[0]) : 0;
  };

  const valorDe = obterPrimeiroPreco(precoDe.textContent || "");
  const valorBase = obterPrimeiroPreco(parcela.textContent || "");

  if (!valorDe || !valorBase) return;

  if (Math.abs(valorDe - valorBase) < 0.01) {
    precoDe.style.display = "none";
    return;
  }

  precoDe.style.display = "";
}

const verificarFabricante = () => {
  document.querySelectorAll(".prod-manufacturer").forEach((elemento) => {
    const textoCompleto = elemento.textContent
      .replace(/Marca:/gi, "")
      .trim();

    const possuiLinkComMarca = [...elemento.querySelectorAll("a")]
      .some((link) => link.textContent.trim() !== "");

    const possuiAtributoMarca = [...elemento.attributes]
      .some((atributo) =>
        /fabricante|manufacturer|brand/i.test(atributo.name) &&
        atributo.value.trim() !== "" &&
        atributo.value !== "1"
      );

    const possuiMarca =
      textoCompleto !== "" ||
      possuiLinkComMarca ||
      possuiAtributoMarca;

    elemento.style.display = possuiMarca ? "" : "none";
  });
};

document.addEventListener("DOMContentLoaded", verificarFabricante);

function atualizarPrazoEntrega() {
  const titleEl = document.querySelector("[data-prod-delivery-title]");
  const countEl = document.querySelector("[data-prod-delivery-countdown]");
  const prodDelContainer = document.querySelector('.prod-delivery-container')
  if (!titleEl || !countEl || !prodDelContainer) return;

  const raw = localStorage.getItem(CEP_HEADER_STORAGE_KEY);
  if (!raw) return

  try {
    const json = JSON.parse(raw)
    console.log(json, json?.state?.toLowerCase() !== 'sp', json?.city?.toLowerCase() !== 'são paulo')

    if (json?.state?.toLowerCase() !== 'sp' || json?.city?.toLowerCase() !== 'são paulo') {
      prodDelContainer.style.display = 'none'
      return
    }
    
    prodDelContainer.style.display = ''
    const agora = new Date();
    const horarioCorte = new Date(agora);
    horarioCorte.setHours(13, 0, 0, 0);

    const antesDoCorte = agora < horarioCorte;
    titleEl.textContent = antesDoCorte ? "Chegará hoje" : "Chegará até amanhã";

    if (antesDoCorte) {
      const diffMs = horarioCorte - agora;
      const horas = Math.floor(diffMs / 3.6e6);
      const minutos = Math.floor((diffMs % 3.6e6) / 6e4);
      countEl.textContent = `Comprando em ${horas} horas e ${minutos} minutos`;
    } else {
      countEl.textContent = "";
    }
  } catch (error) {

  }
}

function obterConfigFreteGratisProduto() {
  const config = window.WS_FRETE_GRATIS_CONFIG;

  const valorMinimo =
    Number(config?.valorMinimo) > 0 ? Number(config.valorMinimo) : 250;

  const cidades =
    Array.isArray(config?.cidades) && config.cidades.length
      ? config.cidades
      : [{ cidade: "sao paulo" }];

  return { valorMinimo, cidades };
}

function normalizarTextoFreteGratisProduto(texto) {
  return (texto || "")
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function cepParaNumeroProduto(cep) {
  const digitos = (cep || "").replace(/\D/g, "");
  return digitos ? Number(digitos.padEnd(8, "0").slice(0, 8)) : null;
}

function localizacaoAtendeFreteGratisProduto(loc, cidades) {
  if (!loc) return false;

  const cidadeCliente = normalizarTextoFreteGratisProduto(loc.city);
  const estadoCliente = normalizarTextoFreteGratisProduto(loc.state);
  const cepCliente = cepParaNumeroProduto(loc.zipcode);

  if (
    estadoCliente === "sp" &&
    cepCliente != null &&
    cepCliente >= 1000000 &&
    cepCliente <= 5999999
  ) {
    return true;
  }

  return cidades.some((entrada) => {
    const cepInicio = cepParaNumeroProduto(entrada.cepInicio);
    const cepFim = cepParaNumeroProduto(entrada.cepFim);

    if (cepCliente != null && cepInicio != null && cepFim != null) {
      return cepCliente >= cepInicio && cepCliente <= cepFim;
    }

    if (entrada.cidade) {
      return cidadeCliente === normalizarTextoFreteGratisProduto(entrada.cidade);
    }

    return false;
  });
}

function clienteLocalizadoEmAreaAtendidaProduto(cidades) {
  try {
    const storageKey =
      typeof CEP_HEADER_STORAGE_KEY !== "undefined"
        ? CEP_HEADER_STORAGE_KEY
        : "ws_customer_location";
    const raw = localStorage.getItem(storageKey);
    if (!raw) return false;
    const loc = JSON.parse(raw);
    return localizacaoAtendeFreteGratisProduto(loc, cidades);
  } catch (e) {
    return false;
  }
}

function textoPrecoParaNumeroProduto(texto) {
  return Number(
    texto
      ?.split("PIX")[0]
      .replace("R$", "")
      .replace(/\s/g, "")
      .replace(/\./g, "")
      .replace(",", "."),
  );
}

function obterValorFreteGratisProduto() {
  const precoEl =
    document.querySelector(".available-section .prod-price-pix") ||
    document.querySelector(".available-section .prod-price-sell");

  const valorDom = textoPrecoParaNumeroProduto(precoEl?.textContent || "");

  if (!Number.isNaN(valorDom) && valorDom > 0) {
    return valorDom;
  }

  const info = wsMain?.globalData?.infoProduto;
  return Number(info?.precos?.preco_promocao || info?.precos?.preco || 0);
}

function adicionarTagFreteGratisNoProduto() {
  if (
    typeof TAG_FRETE_GRATIS_PERSONALIZADA !== "undefined" &&
    TAG_FRETE_GRATIS_PERSONALIZADA === false
  ) return;

  const secaoDisponivel = document.querySelector(".available-section");
  const precoContainer = secaoDisponivel?.querySelector(".prod-price-container");
  const tagsContainer = secaoDisponivel?.querySelector(".prod-tags-container");

  if (!secaoDisponivel || !precoContainer || !tagsContainer) return;

  const tagExistente = secaoDisponivel.querySelector(".prod-tag-frete-personalizada");
  const { valorMinimo, cidades } = obterConfigFreteGratisProduto();
  const clienteAtendido = clienteLocalizadoEmAreaAtendidaProduto(cidades);
  const valor = obterValorFreteGratisProduto();
  const elegivel = clienteAtendido && valor >= valorMinimo;

  if (!elegivel) {
    if (tagExistente) tagExistente.remove();
    return;
  }

  if (tagExistente) return;

  const tag = document.createElement("span");
  tag.className = "prod-tags prod-tag-frete prod-tag-frete-personalizada";
  tag.textContent = "FRETE GRÁTIS*";

  tagsContainer.prepend(tag);
}

function observarTagFreteGratisNoProduto() {
  adicionarTagFreteGratisNoProduto();

  if (window.__observandoTagFreteGratisProduto) return;
  window.__observandoTagFreteGratisProduto = true;

  setTimeout(adicionarTagFreteGratisNoProduto, 300);
  setTimeout(adicionarTagFreteGratisNoProduto, 1000);
  setTimeout(adicionarTagFreteGratisNoProduto, 2500);

  if (document.body) {
    const observer = new MutationObserver(() => {
      adicionarTagFreteGratisNoProduto();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  window.addEventListener("wsCustomerLocationUpdated", adicionarTagFreteGratisNoProduto);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", observarTagFreteGratisNoProduto);
} else {
  observarTagFreteGratisNoProduto();
}

function inicializarModalModelos() {
  const container = document.querySelector(".sub-produtos-container");
  if (!container) return;

  const tentarMontar = () => {
    const tabela = container.querySelector("#LV_TABLE_SUBPRODUTOS");
    if (!tabela || container.classList.contains("tem-tabela-modelos")) return false;
    montarBotaoEModal(container, tabela);
    container.classList.add("tem-tabela-modelos");
    return true;
  };

  if (tentarMontar()) return;

  /* A tabela pode ser injetada apos a etapa pag-produto. */
  const observer = new MutationObserver(() => {
    if (tentarMontar()) observer.disconnect();
  });
  observer.observe(container, { childList: true, subtree: true });
}

function criarElemento(tag, className, parent, conteudo) {
  const el = document.createElement(tag);
  if (className) el.className = className;
  if (conteudo != null) el.textContent = conteudo;
  if (parent) parent.appendChild(el);
  return el;
}

function montarBotaoEModal(container, tabela) {
  // Era "tbody tr" — a tabela vem de wsapi3-pag-prod-rules.js montada via
  // createElement/appendChild puro (não innerHTML), então o <table> nunca
  // ganha um <tbody> implícito (isso só acontece quando o navegador faz o
  // PARSE de HTML em texto; construção via DOM API não insere nada sozinho).
  // "tbody tr" nunca encontrava nada -> linhas.length ficava 0 -> a função
  // retornava sem montar nada (nem botão, nem modal) -- e o "tem-tabela-
  // modelos" era marcado no container do mesmo jeito (ver tentarMontar, mais
  // abaixo), escondendo a tabela crua via CSS (.tem-tabela-modelos
  // #LV_TABLE_SUBPRODUTOS{display:none}). Resultado: nada aparecia. Só
  // nunca foi notado porque nenhum produto real desta loja usava o modo 3
  // (Tabela de opções) antes do VARMODE existir -- a config global sempre
  // foi modo 1.
  const linhas = Array.from(tabela.querySelectorAll("tr")).filter((tr) =>
    tr.querySelector("select[rel]"),
  );
  if (!linhas.length) return;

  const botao = criarElemento(
    "button",
    "btn-abrir-modelos",
    null,
    "Escolha uma op\u00e7\u00e3o de modelo",
  );
  botao.type = "button";
  tabela.insertAdjacentElement("afterend", botao);

  const overlay = criarElemento("div", "modelos-modal-overlay");
  const modal = criarElemento("div", "modelos-modal", overlay);

  const fechar = criarElemento("button", "modelos-modal-close", modal, "\u00d7");
  fechar.type = "button";
  fechar.setAttribute("aria-label", "Fechar");

  const header = criarElemento("div", "modelos-modal-header", modal);

  criarElemento("h3", "modelos-modal-titulo", header, "Escolha os modelos");
  criarElemento(
    "p",
    "modelos-modal-subtitulo",
    header,
    "Escolha pelo menos um modelo e a quantidade que deseja comprar",
  );

  const busca = criarElemento("input", "modelos-modal-busca", header);
  busca.type = "text";
  busca.placeholder = "BUSQUE";

  const body = criarElemento("div", "modelos-modal-body", modal);
  const lista = criarElemento("ul", "modelos-modal-lista", body);

  const itens = linhas.map((tr) => criarItemModal(tr, lista));

  const confirmar = criarElemento(
    "button",
    "modelos-modal-confirma",
    body,
    "ADICIONAR",
  );
  confirmar.type = "button";

  document.body.appendChild(overlay);

  const abrir = () => {
    itens.forEach((item) => item.sincronizarDoSelect());
    overlay.classList.add("aberto");
  };
  const fecharModal = () => overlay.classList.remove("aberto");

  botao.addEventListener("click", abrir);
  fechar.addEventListener("click", fecharModal);
  overlay.addEventListener("click", (ev) => {
    if (ev.target === overlay) fecharModal();
  });
  document.addEventListener("keydown", (ev) => {
    if (ev.key === "Escape" && overlay.classList.contains("aberto")) fecharModal();
  });

  busca.addEventListener("input", () => {
    const termo = busca.value.trim().toLowerCase();
    itens.forEach((item) => {
      const visivel = !termo || item.label.toLowerCase().includes(termo);
      item.el.style.display = visivel ? "" : "none";
    });
  });

  confirmar.addEventListener("click", () => {
    let totalSelecionados = 0;
    itens.forEach((item) => {
      const qtd = item.aplicarNoSelect();
      if (qtd > 0) totalSelecionados += 1;
    });
    fecharModal();

    if (totalSelecionados === 0) {
      botao.textContent = "Escolha uma op\u00e7\u00e3o de modelo";
      return;
    }

    botao.textContent =
      totalSelecionados === 1
        ? "1 modelo selecionado"
        : `${totalSelecionados} modelos selecionados`;

    // Antes s\u00f3 marcava as quantidades nos <select> escondidos e fechava o modal --
    // nada disparava o "adicionar ao carrinho" de fato (o cliente precisava clicar
    // depois no bot\u00e3o de fora, "Adicionar ao carrinho"/"Comprar agora"). O bot\u00e3o
    // "ADICIONAR" do modal agora dispara o fluxo real ele mesmo: wsFuncBtBuy (bridge
    // v2->v3, wsapi3-adaptions-api2-to-api3.js) l\u00ea a tabela #LV_TABLE_SUBPRODUTOS (j\u00e1
    // preenchida acima por aplicarNoSelect), adiciona cada modelo com sua respectiva
    // quantidade, e no final abre a sidebar de confirma\u00e7\u00e3o com os itens reais
    // (openAddedToCartSidebar, wsapi3-pag-prod-rules.js).
    if (typeof wsFuncBtBuy === "function") {
      wsFuncBtBuy('wsMain.modules["pag-produto"].openAddedToCartSidebar()');
    }
  });
}

function criarItemModal(tr, lista) {
  const tds = tr.querySelectorAll("td");
  const select = tr.querySelector("select[rel]");
  const partes = Array.from(tds)
    .slice(0, tds.length - 1)
    .map((td) => td.textContent.trim())
    .filter(Boolean);
  const label = partes.join(" / ");
  const max = Math.max(0, select.options.length - 1);

  const li = criarElemento("li", "modelos-modal-item", lista);
  li.dataset.relSelect = select.id;

  criarElemento(
    "span",
    "modelos-modal-label",
    li,
    label || "Op\u00e7\u00e3o",
  );

  const stepper = criarElemento("div", "modelos-modal-stepper", li);
  const btnMenos = criarElemento(
    "button",
    "modelos-modal-stepper-btn",
    stepper,
    "\u2212",
  );
  btnMenos.type = "button";
  const input = criarElemento("input", "modelos-modal-stepper-input", stepper);
  input.type = "number";
  input.min = "0";
  input.max = String(max);
  input.value = select.value || "0";
  const btnMais = criarElemento(
    "button",
    "modelos-modal-stepper-btn",
    stepper,
    "+",
  );
  btnMais.type = "button";

  const ajustar = (delta) => {
    const atual = parseInt(input.value, 10) || 0;
    const novo = Math.min(max, Math.max(0, atual + delta));
    input.value = String(novo);
  };
  btnMenos.addEventListener("click", () => ajustar(-1));
  btnMais.addEventListener("click", () => ajustar(1));
  input.addEventListener("change", () => {
    const atual = parseInt(input.value, 10) || 0;
    input.value = String(Math.min(max, Math.max(0, atual)));
  });

  return {
    el: li,
    label,
    sincronizarDoSelect() {
      input.value = select.value || "0";
    },
    aplicarNoSelect() {
      const qtd = parseInt(input.value, 10) || 0;
      select.value = String(qtd);
      select.dispatchEvent(new Event("change", { bubbles: true }));
      return qtd;
    },
  };
}

function inicializarPopupComoFunciona() {
  const link = document.querySelector(".headline-how-it-works");
  if (!link) return;

  const overlay = criarElemento("div", "como-funciona-overlay");
  const popup = criarElemento("div", "como-funciona-popup", overlay);

  const fechar = criarElemento("button", "como-funciona-close", popup, "×");
  fechar.type = "button";
  fechar.setAttribute("aria-label", "Fechar");

  const corpo = criarElemento("div", "como-funciona-body", popup);
  criarElemento("h3", "como-funciona-titulo", corpo, "Veja como funciona");
  const textoComoFunciona =
    "Trabalhamos com a modalidade de Entrega Expressa via Motoboy, Flex onde o que foi comprado até o horário de corte 13:00 será enviado no mesmo dia útil, caso a compra tenha sido feita depois do horário de corte, considera-se o envio no próximo dia util seguinte. Para saber mais, ";
  const texto = criarElemento("p", "como-funciona-texto", corpo, textoComoFunciona);
  const linkSaibaMais = criarElemento("a", null, texto, "clique aqui.");
  linkSaibaMais.href = "https://mbastos.com.br/entrega-expressa";
  linkSaibaMais.target = "_blank";
  linkSaibaMais.rel = "noopener";

  document.body.appendChild(overlay);

  const abrir = () => overlay.classList.add("aberto");
  const fecharPopup = () => overlay.classList.remove("aberto");

  link.addEventListener("click", (ev) => {
    ev.preventDefault();
    abrir();
  });
  fechar.addEventListener("click", fecharPopup);
  overlay.addEventListener("click", (ev) => {
    if (ev.target === overlay) fecharPopup();
  });
  document.addEventListener("keydown", (ev) => {
    if (ev.key === "Escape" && overlay.classList.contains("aberto")) fecharPopup();
  });
}

function ocultarSubProdutosVazios() {
  const container = document.querySelector(".sub-produtos-container");
  if (!container) return;

  const subProdutos = container.querySelectorAll(".sub-produtos");
  let algumPreenchido = false;

  subProdutos.forEach((el) => {
    if (el.id == "DivCamposAdd") return;
    const vazio = el.children.length === 0 && el.textContent.trim() === "";
    if (vazio) {
      el.style.display = "none";
    } else {
      algumPreenchido = true;
    }
  });

  if (!algumPreenchido) {
    container.style.display = "none";
  }
}

function moverCompreJuntoAntesPerforma() {
  const mover = () => {
    const compreJunto = document.querySelector("#produtos-compre-junto");
    const secaoCompreJunto = compreJunto?.closest("section") || compreJunto;
    const performa = document.querySelector(
      "performa, #performa2, [id^='performa'], [class*='performa']",
    );

    if (!secaoCompreJunto || !performa || secaoCompreJunto.nextElementSibling === performa) {
      return false;
    }

    performa.parentNode.insertBefore(secaoCompreJunto, performa);
    return true;
  };

  if (mover()) return;

  const observer = new MutationObserver(() => {
    if (mover()) observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => observer.disconnect(), 10000);
}

/*
 * O <h2> de ".sub-produtos-container" e a 1a <option> do combo de variacao vinham
 * fixos ("modelo" no HTML do tema; "Medida" = grupo.tipo, colocado pelo modulo
 * padrao wsapi3-pag-prod-rules). O rotulo tem que refletir o atributo real da
 * variacao (campo "tipo": "Medida", "Cor"...) e o combo deve abrir em "Selecione...".
 */
function ajustarRotuloVariacoes() {
  const container = document.querySelector(".sub-produtos-container");
  if (!container) return;

  const tiposVariacao = () => {
    const vars = wsMain?.globalData?.infoProduto?.variacoes || [];
    const tipos = [];
    vars.forEach((v) => {
      (v.atributos || []).forEach((attr) => {
        const t = (attr.tipo || "").trim();
        if (t && !tipos.includes(t)) tipos.push(t);
      });
    });
    return tipos;
  };

  const aplicar = () => {
    const combos = container.querySelectorAll(
      ".sub-produtos select.LV_COMBO_PROD_GENERO",
    );
    const tipos = tiposVariacao();
    if (!tipos.length && !combos.length) return;

    const titulo = container.querySelector("h2");
    if (titulo && tipos.length) {
      const alvo = `Escolha uma opção de <strong>${tipos
        .join(" e ")
        .toLowerCase()}</strong>`;
      if (titulo.innerHTML.trim() !== alvo) titulo.innerHTML = alvo;
    }

    combos.forEach((combo) => {
      const primeira = combo.options[0];
      if (!primeira || primeira.value !== "") return;
      if (primeira.textContent.trim() !== "Selecione...") {
        primeira.textContent = "Selecione...";
      }
    });
  };

  aplicar();

  /* As variacoes sao injetadas depois da etapa pag-produto e re-renderizadas ao
     filtrar dimensoes; observa a secao e reaplica (o guard de igualdade evita loop). */
  const observer = new MutationObserver(aplicar);
  observer.observe(container, { childList: true, subtree: true });
  setTimeout(() => observer.disconnect(), 10000);
}

try {
  isReady("pag-produto", () => {
    aplicarLabelPix();
    ajustarPrecoDeProduto();
    setTimeout(ajustarPrecoDeProduto, 300);
    setTimeout(ajustarPrecoDeProduto, 1000);
    verificarFabricante();
    atualizarPrazoEntrega();
    observarTagFreteGratisNoProduto();
    ocultarSubProdutosVazios();
    moverCompreJuntoAntesPerforma();
    ajustarRotuloVariacoes();
    inicializarModalModelos();
    inicializarPopupComoFunciona();
    setInterval(atualizarPrazoEntrega, 60000);
  });
} catch (error) {}

function updateCashbackMessage() {
    const cashbackMessage = document.querySelector('.cashback__msg-holder');

    if (!cashbackMessage) return;

    cashbackMessage.innerHTML = cashbackMessage.innerHTML.replace(
        /\s*na compra deste produto\./i,
        ''
    );
}

try {
  isReady("pag-produto", updateCashbackMessage);
} catch (error) {}

function ajustarParcelasPag() {
  document.querySelectorAll(".prod-price-installment-content").forEach((parcela) => {
    const preco = parcela.querySelector(".prod-price-sell")?.textContent.trim();
    const parcelamento = parcela.querySelector(".prod-price-parcela")?.textContent.trim();
    const linkParcelas = parcela
      .closest(".prod-price-installment")
      ?.querySelector(".prod-installments-container");
    const codigoProduto = document
      .querySelector('[data-wsjs-product="code"]')
      ?.textContent.replace(/\D/g, "");

    if (!preco) return;

    /* Este produto possui condicao comercial especifica de duas parcelas. */
    if (codigoProduto === "898324") {
      const valor = Number(
        preco
          .replace(/[^\d,]/g, "")
          .replace(",", ".")
      );
      const valorParcela = (valor / 2).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });

      parcela.style.display = "";
      if (linkParcelas) linkParcelas.style.display = "";
      parcela.textContent = `ou ${preco} em 2x de ${valorParcela} sem juros`;
      return;
    }

    parcela.style.display = "";
    if (linkParcelas) linkParcelas.style.display = "";

    if (parcelamento) {
      parcela.textContent = `ou ${preco} em ${parcelamento}`;
    } else {
      parcela.textContent = `ou ${preco} em 1x de ${preco} sem juros`;
    }
  });
}

try {
  isReady("pag-produto", ajustarParcelasPag);
} catch (error) {}

/* Fecha a imagem ampliada ao clicar diretamente no fundo escuro */
function habilitarFechamentoImagemPeloFundo() {
  const modal = document.querySelector(".modal-div.slide-container");

  if (!modal) return;

  if (window.modalImagemComFechamento && window.fecharImagemPeloFundo) {
    window.modalImagemComFechamento.removeEventListener(
      "click",
      window.fecharImagemPeloFundo,
      true,
    );
  }

  window.fecharImagemPeloFundo = (evento) => {
    if (evento.target !== modal) return;

    modal.setAttribute("style", "display: flex; opacity: 0;");

    setTimeout(() => {
      modal.setAttribute("style", "display: none; opacity: 0;");
    }, 400);
  };

  modal.addEventListener(
    "click",
    window.fecharImagemPeloFundo,
    true,
  );

  window.modalImagemComFechamento = modal;
}

try {
  isReady("pag-produto", habilitarFechamentoImagemPeloFundo);
} catch (error) {}

setTimeout(habilitarFechamentoImagemPeloFundo, 500);
setTimeout(habilitarFechamentoImagemPeloFundo, 1500);

/* Reorganiza o grid da pagina de produto no desktop */
function reorganizarGridPaginaProdutoDesktop() {
  if (!window.matchMedia("(min-width: 769px)").matches) return;

  const estrutura = document.querySelector(".prod-inside-container");
  const colunas = estrutura
    ? Array.from(estrutura.children).filter((elemento) =>
        elemento.classList.contains("prod-side-container"),
      )
    : [];
  const colunaProduto = colunas[0];
  const colunaPreco = colunas[1];
  const cabecalho = colunaProduto?.querySelector(".prod-header-container");
  const breadcrumb = document.querySelector(".breadcrumb-container");
  const metadados = cabecalho?.querySelector(".prod-header-meta");
  const avaliacaoCompartilhamento = cabecalho?.querySelector(
    ".prod-header-rating-share",
  );
  const gradePreco = colunaPreco?.querySelector(".available-section");

  if (
    !estrutura ||
    !colunaProduto ||
    !colunaPreco ||
    !cabecalho ||
    !breadcrumb ||
    !metadados ||
    !avaliacaoCompartilhamento ||
    !gradePreco
  ) {
    return;
  }

  colunaPreco.classList.add("codex-coluna-preco");

  if (breadcrumb.parentElement !== colunaPreco) {
    colunaPreco.insertBefore(breadcrumb, gradePreco);
  }

  if (avaliacaoCompartilhamento.parentElement !== metadados) {
    metadados.appendChild(avaliacaoCompartilhamento);
  }
}

try {
  isReady("pag-produto", reorganizarGridPaginaProdutoDesktop);
} catch (error) {}

setTimeout(reorganizarGridPaginaProdutoDesktop, 500);
setTimeout(reorganizarGridPaginaProdutoDesktop, 1500);
